import { Grid, Paper, Typography } from "@mui/material";
import { estrapolaData } from "../../functions/utils";
import { Box } from "@mui/system";
import { AuthComp } from "../../auth/AuthComp";
import { Redirect } from "../tools/Redirect";
import { DETTAGLIOINVITOSOLLECITOCL, LOGIN } from "../../global/urlMapping";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { inviteReminderSelector } from "../../modules/screening/selectors";
import { getInviteReminderAction } from "../../modules/screening/actions";
import { useNavigate } from "react-router-dom";
import { switchInviteDesc } from "../../api/apiAdaptation";


export const InvitiSolleciti = ({ campagna }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const inviteReminders = useSelector(inviteReminderSelector)

    const isEmptyInviteReminders = () => {
        return inviteReminders?.value?.screeningInvites?.filter(
            (elem) => elem.screeningTypeCode === campagna
        ).length === 0
            ? true : false
    }

    useEffect(() => {
        dispatch(getInviteReminderAction())
    }, [dispatch])
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <AuthComp fallback={<Redirect link={LOGIN} />}>

            <Box className={isEmptyInviteReminders() ? "bgEmpty" : 'bg'}
                sx={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    with: "100%"
                }}>
                <Box sx={{ x: 'auto' }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>

                            <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                <Typography
                                    component='h1'
                                    sx={{
                                        color: "#005397",
                                        margin: "auto",
                                        textAlign: "center",
                                        fontSize: { xs: "25px", md: "40px" },
                                        fontWeight: 700,
                                    }}
                                >
                                    Archivio di inviti e solleciti
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ my: 4, mx: 'auto', paddingBottom: "20vh" }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>
                            <Box
                                sx={{
                                    width: "80%",
                                    margin: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                {isEmptyInviteReminders() &&
                                    <Box
                                        sx={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "auto",
                                            flexDirection: "column",
                                            backgroundColor: "transparent ",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#005397",
                                                fontSize: { xs: "30px", md: "45px" },
                                                fontWeight: 700,
                                                margin: "auto",
                                                textAlign: "center",
                                                width: "60%",
                                                wordWrap: "inherit",
                                            }}
                                        >
                                            Al momento non sono presenti inviti da visualizzare.
                                        </Typography>

                                    </Box>
                                }

                                {
                                    inviteReminders?.status === 200 && !isEmptyInviteReminders() &&
                                    inviteReminders?.value?.screeningInvites?.filter(element => element.screeningTypeCode === campagna).reverse().map((element, index) =>
                                    (
                                        <Paper className='change-cursor' key={index} elevation={5}
                                            sx={{
                                                maxWidth: '100%',
                                                minWidth: '40%',
                                                textDecoration: "none",
                                                backgroundColor: 'white',
                                                borderRadius: '20px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                mb: "10px",
                                                textAlign: "center",
                                                alignSelf: 'center'
                                            }}
                                            onClick={() => { navigate(DETTAGLIOINVITOSOLLECITOCL, { state: { element } }); }}

                                        >
                                            <Box sx={{ minHeight: '150px', backgroundColor: 'transparent', margin: '20px', display: "flex", flexDirection: "column", alignItems: "flex-end" }}

                                            >
                                                <Typography component="span" sx={{ color: "white", backgroundColor: ((element?.status === "INVITED" && element?.type === "REMINDER") || element?.status === "DECLINED" || element?.status === "DECLINED_PERM") ? "red" : "green", borderRadius: "10px", fontSize: '25px', fontWeight: 700, paddingX: '8px' }}>
                                                    {element.statusDesc}
                                                </Typography>
                                                <Typography component="span" sx={{ paddingTop: '2vh', margin: ' auto', color: '#005397', fontSize: '20px', textAlign: 'left', fontWeight: 700 }}>
                                                    {estrapolaData(element.inviteDate)}
                                                </Typography>
                                                <Typography component="h2" sx={{ margin: ' auto', color: '#005397', fontSize: '25px', textAlign: 'left', fontWeight: 700 }}>
                                                    {element.screeningTypeDesc}
                                                </Typography>
                                                <Typography sx={{ margin: ' auto', color: '#005397', fontSize: '20px', textAlign: 'left', fontWeight: 500 }}>
                                                    {switchInviteDesc(element)}
                                                </Typography>
                                            </Box>
                                        </Paper>
                                    ))
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </AuthComp >

    );
}